export default __webpack_public_path__ + "static/media/top-triangles.02dcbd65.svg";